<template>
  <div class="big benevolenceDetails">
    <div class="page_title flex_between">
      <span>医生仁心值明细</span>
      <el-button type="primary" style="width: 120px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <div class="doctor-info">
          <div class="item">
            <span class="title">医生姓名: </span>
            <span>{{ doctor_info.doctor_name }}</span>
          </div>
          <div class="item">
            <span class="title">手机号: </span>
            <span>{{ doctor_info.phone }}</span>
          </div>
          <div class="item">
            <span class="title">职称: </span>
            <span>{{ doctor_info.title }}</span>
          </div>
          <div class="item">
            <span class="title">医院: </span>
            <span>{{ doctor_info.hospital }}</span>
          </div>
        </div>

        <div class="statistics-card">
          <el-card
            class="box-card"
            v-for="(item, index) in statisticsData"
            :key="index"
          >
            <img :src="item.url" />
            <div class="desc">
              <div class="value">{{ item.value }}</div>
              <div class="title">{{ item.title }}</div>
            </div>
          </el-card>
        </div>

        <div class="search-box">
          <!-- 变动时间 -->
          <div class="item">
            <span style="margin-left: 10px">变动时间</span>
            <div class="item-content">
              <el-date-picker
                v-model="benevolenceForm.changeTime"
                size="small"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="getList"
              >
              </el-date-picker>
            </div>
          </div>

          <!-- 变动类型 -->
          <div class="item">
            <span style="margin-left: 10px">变动类型</span>
            <div class="item-content">
              <el-select
                v-model="benevolenceForm.type"
                size="small"
                clearable
                @change="getList"
                placeholder="结算状态"
              >
                <el-option label="入账" :value="1"></el-option>
                <el-option label="消费" :value="2"></el-option>
                <el-option label="失效" :value="3"></el-option>
                <el-option label="自动赠送" :value="4"></el-option>
              </el-select>
            </div>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="getList"
              >查询</el-button
            >
            <el-button size="small" @click="restBtn">重置</el-button>
            <el-button
              type="primary"
              size="small"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1084') : false
              "
              @click="addDetail"
              >添加明细</el-button
            >
            <el-button
              type="primary"
              size="small"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1083') : false
              "
              @click="exportDetail"
              >导出</el-button
            >
          </div>
        </div>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="benevolenceData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>
                <div v-else-if="item.prop == 'type'">
                  {{ scope.row[item.prop] | typeText }}
                </div>
                <div v-else>
                  {{
                    JSON.stringify(scope.row[item.prop]) === "null"
                      ? ""
                      : scope.row[item.prop]
                  }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
    <!-- 添加明细 -->
    <el-dialog
      title="添加明细"
      :visible.sync="dialogFormVisible"
      custom-class="benevolence-details-dia"
      width="600px"
    >
      <el-form
        :model="detailsForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
      >
        <el-form-item label="变动时间" prop="create_time">
          <el-date-picker
            v-model="detailsForm.create_time"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            type="datetime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="变动类型" prop="type">
          <el-select v-model="detailsForm.type" placeholder="请选择">
            <el-option label="入账" value="1"></el-option>
            <el-option label="消费" value="2"></el-option>
            <el-option label="失效" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="变动数值" prop="heart_num">
          <el-input-number
            v-model="detailsForm.heart_num"
            :min="0"
            :max="999999"
            :precision="0"
            :controls="false"
            size="medium"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="变动备注" prop="remark">
          <el-input
            v-model="detailsForm.remark"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="100"
            show-word-limit
            placeholder="请输入"
          >
          </el-input>
        </el-form-item>
        <div class="prompt">
          变动数值只需填入数值，系统自动计算入账为+，消费和失效为-
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDetails('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="confirmDetails('ruleForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import marketing from "@/api/marketing.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      benevolenceForm: {
        type: "",
        changeTime: [],
      },
      tableHeader: [
        {
          label: "变动时间",
          prop: "create_time",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "变动类型",
          prop: "type",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "变动数值",
          prop: "heart_num",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "余额",
          prop: "balance_heart_num",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "变动备注",
          prop: "remark",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      benevolenceData: [],
      doctor_info: {},
      detailsForm: {
        create_time: "",
        type: "",
        heart_num: "",
        remark: "",
      },
      rules: {
        create_time: {
          required: true,
          message: "请选择时间",
          trigger: "change",
        },
        type: { required: true, message: "请选择类型", trigger: "change" },
        heart_num: { required: true, message: "请输入数值", trigger: "blur" },
        remark: { required: true, message: "请输入备注", trigger: "blur" },
      },
      dialogFormVisible: false,
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    typeText(val) {
      switch (val) {
        case 1:
          return "入账";
        case 2:
          return "消费";
        case 3:
          return "失效";
        case 4:
          return "自动赠送";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routeQuery() {
      return this.$route.query;
    },
    statisticsData() {
      return [
        {
          url: require("../../../assets/img/benevolence/current_renxin.png"),
          title: "当前仁心值总计",
          value: this.doctor_info.heart_num,
        },
        {
          url: require("../../../assets/img/benevolence/used_renxin.png"),
          title: "已用仁心值总计",
          value: this.doctor_info.use_heart_num,
        },
        {
          url: require("../../../assets/img/benevolence/failure_renxin.png"),
          title: "失效仁心值总计",
          value: this.doctor_info.cancel_heart_num,
        },
      ];
    },
  },
  created() {
    if (this.$route.query.changeTime) {
      this.benevolenceForm.changeTime = this.$route.query.changeTime;
    }
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign(this.pagination, this.benevolenceForm, {
        doctor_id: this.routeQuery.doctor_id,
      });
      params = _.omit(params, ["changeTime"]);
      let changeTime = this.benevolenceForm.changeTime;
      params["start_time"] = changeTime ? changeTime[0] : "";
      params["end_time"] = changeTime ? changeTime[1] : "";
      const loading = this.$loading();
      this.tableLoading = true;
      marketing
        .doctorHeartAccountDetail(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.benevolenceData = data.list;
            this.doctor_info = data.info;
            this.totalNum = data.total;
            this.tableLoading = false;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    addDetail(row) {
      this.dialogFormVisible = true;
    },
    exportDetail() {
      const loading = this.$loading();
      let params = Object.assign(this.routeQuery, this.benevolenceForm);
      params = _.omit(params, ["changeTime"]);
      let changeTime = this.benevolenceForm.changeTime;
      params["start_time"] = changeTime ? changeTime[0] : "";
      params["end_time"] = changeTime ? changeTime[1] : "";
      marketing
        .exportDoctorHeartAccountDetail(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            let host = `${document.location.protocol}//${window.location.host}${data.url}`;
            location.href = host;
            this.$message.success("导出成功");
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    restBtn() {
      for (let key in this.benevolenceForm) {
        if (key == "create_time") {
          this.benevolenceForm[key] = [];
        } else {
          this.benevolenceForm[key] = "";
        }
      }
      this.getList();
    },
    confirmDetails(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading();
          let params = Object.assign(this.routeQuery, this.detailsForm);
          marketing
            .addDoctorHeartAccountDetail(params)
            .then((res) => {
              let { code } = res;
              if (code == 0) {
                this.$message.success("添加成功");
                this.dialogFormVisible = false;
                this.getList();
                this.$refs[formName].resetFields();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    cancelDetails(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    back() {
      history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.benevolenceDetails {
  .doctor-info {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .item {
      margin-right: 30px;
      .title {
        width: 100px;
      }
    }
  }
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
  .statistics-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    .box-card {
      width: 30%;
      ::v-deep .el-card__body {
        display: flex;
        align-items: center;
        justify-content: space-around;
        img {
          width: 80px;
          height: 80px;
        }
        .desc {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .value {
            font-size: 20px;
            font-weight: bold;
          }
          .title {
            padding: 10px 0;
          }
        }
      }
    }
  }
}
.benevolence-details-dia {
  .el-form {
    padding-top: 10px;
    padding-left: 20px;
    .el-form-item {
      display: flex;
      align-items: center;
    }
    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .el-date-editor {
    width: 400px;
  }
  .el-select {
    width: 400px;
  }
  .el-input-number {
    width: 400px;
    ::v-deep .el-input__inner {
      text-align: left;
    }
  }
  .el-textarea {
    width: 400px;
  }
  .prompt {
    font-size: 12px;
    text-align: left;
    color: red;
    padding-left: 10px;
    margin-bottom: 0;
    height: auto;
  }
}
</style>
